// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-upload-container {
  display: flex;
}
@media screen and (max-width: 850px) {
  .image-upload-container {
    flex-direction: column;
  }
}
.image-upload-container.df-column {
  flex-direction: column;
}
.image-upload-container.img-preview {
  gap: 13px;
}
.image-upload-container .img-preview-cont {
  padding: 10px 10px 10px 0;
}
@media screen and (max-width: 850px) {
  .image-upload-container .img-preview-cont {
    display: flex;
    flex-direction: column;
  }
}
.image-upload-container .img-preview-cont img {
  max-width: 100px;
}
.image-upload-container .img-preview-cont .rem-img-btn {
  min-width: 121px;
  max-width: 150px;
  height: 32px;
  font-size: 13px;
  margin-top: 10px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
